module.exports = __webpack_public_path__ + "img/ic-maestrocard.86533f9d.svg";